export default __webpack_public_path__ + "static/media/to_be_announced.975e9371.png";